import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Dialog,
  DialogContent,
  Autocomplete,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import EditIcon from "@mui/icons-material/Edit";
import "react-lazy-load-image-component/src/effects/blur.css";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseArticles } from "./UseArticles";
import { useSnackbar } from "notistack";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import SearchComOff from "../firstPage/HomeOffer/SearchComOff";

export default function ArticleProductsGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    GetArticleProducts,
    AddArticleProduct,
    DeleteArticleProduct,
    EditArticleProduct,
  } = UseArticles();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [openDialog, setOpenDialog] = useState(false);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [ProductsRes, setProductsRes] = useState([]);
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [state, setState] = useState({
    articleID: undefined,
    productID: "",
  });

  useEffect(() => {
    if (props.articleID) {
      setState({ ...state, articleID: props.articleID });
      setProgress(true);
      GetArticleProducts(props.articleID, (callback) => {
        setProductsRes(callback);
      });
    }
  }, [props.articleID]);

  useEffect(() => {
    setFilt([
      {
        columnField: "resource",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    setOpenDialog(true);
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "productID",
      width: 80,
      align: "center",
      headerName: "کد",
      headerAlign: "center",
    },
    {
      field: "productName",
      width: 350,
      align: "center",
      headerName: "نام محصول",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {cellValues.row.productName}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 140,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.productName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  orderRow: cellValues.row.orderRow - 1,
                };
                if (cellValues.row.orderRow - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  EditArticleProduct(model, () =>
                    GetArticleProducts(props.articleID, (callback) => {
                      setProductsRes(callback);
                    })
                  );
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  orderRow: cellValues.row.orderRow + 1,
                };
                if (cellValues.row.orderRow + 1 == ProductsRes.length + 1) {
                  return;
                } else {
                  setProgress(true);
                  EditArticleProduct(model, () =>
                    GetArticleProducts(props.articleID, (callback) => {
                      setProductsRes(callback);
                    })
                  );
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog}
        onClose={() => {
          setState({
            articleID: props.articleID,
            productID: "",
          });
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <SearchComOff
              article
              productID={state.productID}
              productModel={state}
              setProductModel={setState}
            />

            <Box sx={{ mt: 2 }}>
              <Button
                onClick={() => {
                  if (
                    state.productID == "" ||
                    state.productID == undefined ||
                    state.productID == null
                  ) {
                    enqueueSnackbar("لطفا محصول را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  } else {
                    setProgress(true);
                    AddArticleProduct(state, () => {
                      setState({
                        articleID: props.articleID,
                        productID: "",
                      });
                      GetArticleProducts(props.articleID, (callback) => {
                        setProductsRes(callback);
                      });
                      setOpenDialog(false);
                    });
                  }
                }}
                color="secondary"
                variant="contained"
              >
                ثبت
              </Button>
              <Button
                sx={{ ml: 2 }}
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setState({
                    articleID: props.articleID,
                    productID: "",
                  });
                  setOpenDialog(false);
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {ProductsRes ? (
        <DataGrid
          className="ltr-grid"
          filterModel={{
            items: filt,
          }}
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={ProductsRes ? ProductsRes : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={ProductsRes && ProductsRes.length ? ProductsRes.length : 1}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              isLtr: true,
              rowCount:
                ProductsRes && ProductsRes.length ? ProductsRes.length : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "rowIndex",
                  sort: "asc",
                },
              ],
            },
          }}
        />
      ) : (
        ""
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"محصول"}
        callback={() => {
          setProgress(true);
          DeleteArticleProduct(deleteState.id, () => {
            GetArticleProducts(props.articleID, (callback) => {
              setProductsRes(callback);
            });
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
